function enable() {
  //  private
  let result = false;
  try {
    localStorage.setItem("test_key", "1");
    if (localStorage.getItem("test_key") === "1") {
      result = true;
    }
  } catch (e) {
    // pass
    console.log(e);
  }
  return result;
}

export const enableLocalStorage = enable();

export function getItem(key) {
  if (enableLocalStorage) {
    return JSON.parse(String(localStorage.getItem(key)));
  }
  return null;
}

export function setItem(key, value) {
  if (enableLocalStorage) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
